import React, { Component } from 'react';
import {TweenMax, TimelineMax} from 'gsap';
import fa from '@fortawesome/fontawesome';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SolidIcons from '@fortawesome/fontawesome-free-solid'

export default class TextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      error: "",
      valid: this.props.isRequired && this.props.isRequired !== false ? false : true,
      showError: false
    }
    this.maxLength = 1500;
  }

  componentDidMount() {
    fa.library.add(SolidIcons);
  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
    if (this.props.showError === true && this.state.showError === false) {
      this.validate(this.Input);
    }
    this.adjustErrorHeight();
  }

  getIcon = () => {
    return fa.findIconDefinition({iconName: this.props.icon})
  }

  handleChange = (e) => {
    this.validate(e.target);
    this.adjustErrorHeight();
    this.props.onChange(e);
  }

  validate = (target) => {
    if (!target) return;
    if (this.props.isRequired && this.props.isRequired !== false) {
      var valid = true, errMsg = "";
      if (target.value.length === 0) {
        valid = false;
        errMsg = "Required";
      }
      this.setState({value: target.value, error: errMsg, valid: valid, showError: true});
    } else {
      this.setState({value: target.value, error: "", valid: true, showError: true});
    }
  }

  adjustErrorHeight = () => {
    if ((this.state.showError && this.state.error !== "") || this.characterLimitApproaching()) {
      TweenMax.to(this.container, 0.25, {marginBottom: (this.error.getBoundingClientRect().height - 9)})
    } else {
      TweenMax.to(this.container, 0.25, {marginBottom: 0})
    }
  }

  characterLimitApproaching = () => {
    return this.maxLength - this.state.value.length <= (this.maxLength/10)
  }

  toggleFocus = (on) => {
    if (on) {
      if (this.container.className.indexOf("focused") == -1)
        this.container.className += " focused";
    } else {
      this.container.className = this.container.className.replace(" focused", "");
    }
  }

  getErrorMessage = () => {
    const charLimit = this.characterLimitApproaching();
    const isErr = this.state.showError && this.state.error

    let errorMsg = isErr ? this.state.error : null
    errorMsg = errorMsg && charLimit ? ' - ' : ''

    let charLimitMsg = charLimit ? `${this.maxLength - this.state.value.length} characters left` : ''

    return isErr || charLimit ? (
      <span className="error" ref={el => this.error = el}>
        { errorMsg }{ charLimitMsg }
      </span>
    ) : null
  }

  render() {
    return (
      <div className="TextArea" ref={el => this.container = el}>
        { this.props.icon &&
          <div className={"input-icon" + (this.props.mirrored ? " mirrored" : "")}>
            <FontAwesomeIcon icon={this.getIcon()} />
          </div>
        }
        <label htmlFor={this.props.id} className="Label">
          {this.state.value === "" && this.props.label}
        </label>
        { this.getErrorMessage() }
        <textarea value={this.state.value} id={this.props.id} onChange={this.handleChange} className="TextField"
          ref={el => this.Input = el}
          onFocus={this.toggleFocus.bind(this, true)}
          onBlur={this.toggleFocus.bind(this, false)}
          maxLength={this.maxLength} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/TextArea/TextArea.js